import gql from 'graphql-tag';

import accountCardDetails from '../fragments/accountCardDetails';

const getAccountCardQuery = gql`
  query getAccountCardQuery($id: RecordID!) {
    accountCard(id: $id) {
      ...accountCardDetails
    }
  }
  ${accountCardDetails}
`;

export default getAccountCardQuery;
